module.exports = "https://beta.voredev.ru/assets/index/check-mark-e8785c54646c699d8cd3e22186d8f563.svg";